import { cn } from 'cn'
import Image from 'components/Image'
import NullsToUndefined from 'utils/NullsToUndefined'
import { ItemTagFragment } from 'components/Tag/types/ItemTagFragment'

import getTagStyle from './getTagStyle'

type Props = {
  tag: NullsToUndefined<ItemTagFragment>
  hideName?: boolean
}

const Tag = ({ tag, hideName = false }: Props) => {
  if (hideName) {
    if (!tag.imageSvgUrl) return null
    return (
      <div className="flex items-center justify-center w-6 h-6 lg:w-9 lg:h-9 m-0.5 rounded-full bg-white shadow-xs">
        <div className="relative w-[15px] h-[15px] lg:w-[22px] lg:h-[22px]">
          <Image
            alt={tag.name}
            layout="fill"
            objectFit="contain"
            src={tag.imageSvgUrl}
          />
        </div>
      </div>
    )
  }

  const style = getTagStyle(tag.color)

  return (
    <div
      className={cn(
        'flex items-center mb-1.5 mr-2 px-2.5 py-1 rounded-full shadow-xs',
        style.pillClassName
      )}
    >
      {tag.imageSvgUrl && (
        <span className="flex mr-1.5">
          <Image alt={tag.name} height={14} src={tag.imageSvgUrl} width={14} />
        </span>
      )}
      <p className={cn('text-xs font-semibold', style.textClassName)}>
        {tag.name}
      </p>
    </div>
  )
}

export default Tag
